import { createContext } from 'react'

const ACLContext = createContext({
  openUserManagerModal: value => value,
})
export { ACLContext }
